// @flow
import React, { Component } from 'react';
import SubscriptionRulesLoader from './components/SubscriptionRulesLoader';
import VpPolicyAlignmentPrompt from './components/VpPolicyAlignmentPrompt';
import Routes from './routes/Routes';

// setup fake backend
// import { configureFakeBackend } from './helpers';

import { ReactNotifications } from 'react-notifications-component';
import 'react-notifications-component/dist/theme.css';
import 'animate.css/animate.min.css';
import { clearNotifications } from './helpers/notification';

// Themes
import './assets/scss/Saas.scss';

// For Dark import Saas-Dark.scss
// import './assets/scss/Saas-Dark.scss';

// For Modern import Modern.scss
// import './assets/scss/Modern.scss';
// For modern dakr import Modern-Dark.scss
// import './assets/scss/Modern-Dark.scss';

// For Creative demo import Modern.scss
// import './assets/scss/Creative.scss';
// For Creative dark demo import Modern.scss
// import './assets/scss/Creative-Dark.scss';

// configure fake backend
// configureFakeBackend();

/**
 * Main app component
 */
class App extends Component {
  componentDidMount() {
    // Clear notifications on browser navigation changes.
    window.addEventListener('popstate', clearNotifications);
    window.addEventListener('hashchange', clearNotifications);
  }

  componentWillUnmount() {
    window.removeEventListener('popstate', clearNotifications);
    window.removeEventListener('hashchange', clearNotifications);
  }

  render() {
    return (
      <React.Fragment>
        <ReactNotifications />
        <SubscriptionRulesLoader />
        <VpPolicyAlignmentPrompt />
        <Routes />
      </React.Fragment>
    );
  }
}

export default App;
